module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAACXBIWXMAACE3AAAhNwEzWJ96AAAAVklEQVRoge3RwQmAMBAEwItYljXZgtqCNdmXPoQQAr4UMTjzvc/uXgAAAAAAcErlDvs4zC3vktYt5++r2/R+nEflYl3jRS7VH1s+lA0AAPg9AADui4gDMwMFjIOWYlUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@3x/ic_btn_minus@3x.png
// module id = 310
// module chunks = 0